module.exports = __webpack_public_path__ + "media/images/emblems/Bretonnieres-coat_of_arms-4e2023061bee5dba0211873c53332c9c.svg";